export enum CashbackType
{
    Unknown = 0,
    Save = 1,
    Spend = 2,
    Donate = 3
}